import { render, staticRenderFns } from "./details.vue?vue&type=template&id=b4a0f5a2&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=b4a0f5a2&prod&scoped=true&lang=scss"
import style1 from "./details.vue?vue&type=style&index=1&id=b4a0f5a2&prod&lang=css"
import style2 from "./details.vue?vue&type=style&index=2&id=b4a0f5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a0f5a2",
  null
  
)

export default component.exports